import { styled } from '@mui/material/styles';
import { ReactNode } from 'react';
import { Section } from '../Section/Section';

const WrapperContainer = styled('div')({
  width: '100%',
  maxWidth: '920px',
  margin: '0 auto',
  padding: '0 20px',
});

interface WrapperProps {
  children: ReactNode;
}

export const Wrapper = ({ children }: WrapperProps) => {
  return (
    <WrapperContainer>
      {children}
    </WrapperContainer>
  );
};

export { Section };
